var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 211.832,
    height: 294.607,
    viewBox: "0 0 211.832 294.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(-14946 -9831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M402.606,102.606H383.035c1.828,2.644-112.8,0-112.8,0H251.95c-16.893,0-30.588,8.081-30.588,18.049V349.4c0,9.968,13.7,18.049,30.588,18.049H402.606c16.893,0,30.588-8.081,30.588-18.049h0V120.654C433.194,110.686,419.5,102.606,402.606,102.606Z",
    transform: "translate(14724.638 9758.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M249.958,371.942a.646.646,0,0,1-.646-.646V348.685a.646.646,0,0,1,1.292,0V371.3a.646.646,0,0,1-.646.642Z",
    transform: "translate(14714.744 9610.023)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M256.958,373.549a.646.646,0,0,1-.646-.646V343.185a.646.646,0,0,1,1.292,0V372.9a.646.646,0,0,1-.646.649Z",
    transform: "translate(14712.266 9612.325)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M263.958,374.571a.646.646,0,0,1-.646-.646v-34.24a.646.646,0,0,1,1.292,0v34.239a.646.646,0,0,1-.646.647Z",
    transform: "translate(14709.788 9613.796)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M270.958,377.2a.646.646,0,0,1-.646-.646V330.685a.646.646,0,1,1,1.292,0v45.868a.646.646,0,0,1-.646.647Z",
    transform: "translate(14707.311 9617.602)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M277.958,381.142a.646.646,0,0,1-.646-.646V317.185a.646.646,0,1,1,1.292,0V380.5A.646.646,0,0,1,277.958,381.142Z",
    transform: "translate(14704.833 9623.381)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M284.958,377.2a.646.646,0,0,1-.646-.646V330.685a.646.646,0,1,1,1.292,0v45.868a.646.646,0,0,1-.646.647Z",
    transform: "translate(14702.354 9617.602)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M291.958,379.1a.646.646,0,0,1-.646-.646V324.185a.646.646,0,0,1,1.292,0v54.266a.646.646,0,0,1-.646.649Z",
    transform: "translate(14699.877 9620.373)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M298.958,374.133a.646.646,0,0,1-.646-.646v-32.3a.646.646,0,0,1,1.292,0v32.3a.646.646,0,0,1-.646.646Z",
    transform: "translate(14697.398 9613.165)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M305.958,375.3a.646.646,0,0,1-.646-.646v-37.47a.646.646,0,0,1,1.292,0v37.47A.646.646,0,0,1,305.958,375.3Z",
    transform: "translate(14694.922 9614.85)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M312.958,371.942a.646.646,0,0,1-.646-.646V348.685a.646.646,0,0,1,1.292,0V371.3a.646.646,0,0,1-.646.642Z",
    transform: "translate(14692.443 9610.023)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M318.958,371.942a.646.646,0,0,1-.646-.646V348.685a.646.646,0,0,1,1.292,0V371.3a.646.646,0,0,1-.646.642Z",
    transform: "translate(14690.32 9610.023)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M325.958,373.549a.646.646,0,0,1-.646-.646V343.185a.646.646,0,1,1,1.292,0V372.9a.646.646,0,0,1-.646.649Z",
    transform: "translate(14687.842 9612.325)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M332.958,374.571a.646.646,0,0,1-.646-.646v-34.24a.646.646,0,0,1,1.292,0v34.239a.646.646,0,0,1-.646.647Z",
    transform: "translate(14685.364 9613.796)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M339.958,377.2a.646.646,0,0,1-.646-.646V330.685a.646.646,0,0,1,1.292,0v45.868a.646.646,0,0,1-.646.647Z",
    transform: "translate(14682.887 9617.602)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M346.958,385.815a.646.646,0,0,1-.646-.646V301.185a.646.646,0,1,1,1.292,0v83.983a.646.646,0,0,1-.646.647Z",
    transform: "translate(14680.409 9630.354)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M353.958,377.2a.646.646,0,0,1-.646-.646V330.685a.646.646,0,1,1,1.292,0v45.868a.646.646,0,0,1-.646.647Z",
    transform: "translate(14677.931 9617.602)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M360.958,379.1a.646.646,0,0,1-.646-.646V324.185a.646.646,0,0,1,1.292,0v54.266a.646.646,0,0,1-.646.649Z",
    transform: "translate(14675.453 9620.373)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M367.958,374.133a.646.646,0,0,1-.646-.646v-32.3a.646.646,0,0,1,1.292,0v32.3a.646.646,0,0,1-.646.646Z",
    transform: "translate(14672.975 9613.165)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M374.958,375.3a.646.646,0,0,1-.646-.646v-37.47a.646.646,0,0,1,1.292,0v37.47a.646.646,0,0,1-.646.646Z",
    transform: "translate(14670.497 9614.85)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M381.958,371.942a.646.646,0,0,1-.646-.646V348.685a.646.646,0,0,1,1.292,0V371.3a.646.646,0,0,1-.646.642Z",
    transform: "translate(14668.02 9610.023)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M387.958,371.942a.646.646,0,0,1-.646-.646V348.685a.646.646,0,0,1,1.292,0V371.3a.646.646,0,0,1-.646.642Z",
    transform: "translate(14665.896 9610.023)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M394.958,373.549a.646.646,0,0,1-.646-.646V343.185a.646.646,0,1,1,1.292,0V372.9a.646.646,0,0,1-.646.649Z",
    transform: "translate(14663.418 9612.325)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M401.958,374.571a.646.646,0,0,1-.646-.646v-34.24a.646.646,0,0,1,1.292,0v34.239a.646.646,0,0,1-.646.647Z",
    transform: "translate(14660.939 9613.796)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M408.958,377.2a.646.646,0,0,1-.646-.646V330.685a.646.646,0,1,1,1.292,0v45.868a.646.646,0,0,1-.646.647Z",
    transform: "translate(14658.462 9617.602)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M415.958,381.142a.646.646,0,0,1-.646-.646V317.185a.646.646,0,1,1,1.292,0V380.5A.646.646,0,0,1,415.958,381.142Z",
    transform: "translate(14655.984 9623.381)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M420.958,394.065a.646.646,0,0,1-.646-.646V272.935a.646.646,0,1,1,1.292,0V393.419a.646.646,0,0,1-.646.646Z",
    transform: "translate(14654.215 9643.071)",
    fill: "#7315ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M422.958,377.2a.646.646,0,0,1-.646-.646V330.685a.646.646,0,0,1,1.292,0v45.868a.646.646,0,0,1-.646.647Z",
    transform: "translate(14653.507 9617.602)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M429.958,379.1a.646.646,0,0,1-.646-.646V324.185a.646.646,0,1,1,1.292,0v54.266a.646.646,0,0,1-.646.649Z",
    transform: "translate(14651.029 9620.373)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M436.958,374.133a.646.646,0,0,1-.646-.646v-32.3a.646.646,0,0,1,1.292,0v32.3a.646.646,0,0,1-.646.646Z",
    transform: "translate(14648.551 9613.165)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M443.958,375.3a.646.646,0,0,1-.646-.646v-37.47a.646.646,0,0,1,1.292,0v37.47A.646.646,0,0,1,443.958,375.3Z",
    transform: "translate(14646.073 9614.85)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M450.958,371.942a.646.646,0,0,1-.646-.646V348.685a.646.646,0,0,1,1.292,0V371.3a.646.646,0,0,1-.646.642Z",
    transform: "translate(14643.595 9610.023)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M456.958,371.942a.646.646,0,0,1-.646-.646V348.685a.646.646,0,0,1,1.292,0V371.3a.646.646,0,0,1-.646.642Z",
    transform: "translate(14641.472 9610.023)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M463.958,373.549a.646.646,0,0,1-.646-.646V343.185a.646.646,0,1,1,1.292,0V372.9a.646.646,0,0,1-.646.649Z",
    transform: "translate(14638.994 9612.325)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M470.958,374.571a.646.646,0,0,1-.646-.646v-34.24a.646.646,0,0,1,1.292,0v34.239a.646.646,0,0,1-.646.647Z",
    transform: "translate(14636.516 9613.796)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M477.958,377.2a.646.646,0,0,1-.646-.646V330.685a.646.646,0,1,1,1.292,0v45.868a.646.646,0,0,1-.646.647Z",
    transform: "translate(14634.038 9617.602)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M484.958,385.815a.646.646,0,0,1-.646-.646V301.185a.646.646,0,0,1,1.292,0v83.983a.646.646,0,0,1-.646.647Z",
    transform: "translate(14631.56 9630.354)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M491.958,377.2a.646.646,0,0,1-.646-.646V330.685a.646.646,0,0,1,1.292,0v45.868a.646.646,0,0,1-.646.647Z",
    transform: "translate(14629.083 9617.602)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M498.958,379.1a.646.646,0,0,1-.646-.646V324.185a.646.646,0,1,1,1.292,0v54.266a.646.646,0,0,1-.646.649Z",
    transform: "translate(14626.604 9620.373)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M505.958,374.133a.646.646,0,0,1-.646-.646v-32.3a.646.646,0,0,1,1.292,0v32.3a.646.646,0,0,1-.646.646Z",
    transform: "translate(14624.127 9613.165)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M512.958,375.3a.646.646,0,0,1-.646-.646v-37.47a.646.646,0,0,1,1.292,0v37.47A.646.646,0,0,1,512.958,375.3Z",
    transform: "translate(14621.648 9614.85)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M519.958,371.942a.646.646,0,0,1-.646-.646V348.685a.646.646,0,0,1,1.292,0V371.3a.646.646,0,0,1-.646.642Z",
    transform: "translate(14619.171 9610.023)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M278.312,626.562v23.063L296.4,638.093Z",
    transform: "translate(14704.479 9442.178)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 12.895,
    cy: 12.941,
    rx: 12.895,
    ry: 12.941,
    transform: "translate(15032.357 10078.645) rotate(-45)",
    fill: "#7315ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M466.963,649.078h-4.425a2.216,2.216,0,0,1-2.216-2.209V630.627a2.222,2.222,0,0,1,2.216-2.216h4.425a2.216,2.216,0,0,1,2.216,2.216v16.248a2.209,2.209,0,0,1-2.216,2.2Zm14.025-2.2V630.627a2.216,2.216,0,0,0-2.209-2.216h-4.432a2.222,2.222,0,0,0-2.216,2.216v16.248a2.216,2.216,0,0,0,2.216,2.209h4.432a2.21,2.21,0,0,0,2.209-2.209Z",
    transform: "translate(14640.052 9441.793)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M410.488,486.71H297.243a.769.769,0,0,1,0-1.538H410.488a.769.769,0,1,1,0,1.538Z",
    transform: "translate(14698.05 9532.031)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M410.488,246.71H297.243a.769.769,0,1,1,0-1.538H410.488a.769.769,0,1,1,0,1.538Z",
    transform: "translate(14698.05 9673.891)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-plus-circle",
    "data-name": "Icon feather-plus-circle",
    transform: "translate(15109.51 9831.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M51.322,27.161a24.417,24.417,0,0,1-9.441,19.16,23.625,23.625,0,0,1-14.72,5A24.161,24.161,0,1,1,51.322,27.16Z",
    transform: "translate(-3 -3)",
    fill: "#7315ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M18,12V31.329",
    transform: "translate(6.161 2.496)",
    fill: "#7315ce",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M12,18H31.329",
    transform: "translate(2.497 6.161)",
    fill: "#7315ce",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioDrop);
export default __webpack_public_path__ + "static/media/audio_drop.a7e29356c095496219d75892444d6eb4.svg";
export { ForwardRef as ReactComponent };